import { createSignal } from 'solid-js';

const [latestMessage, setLatestMessage] = createSignal<MagicDoor.Api.ChatMessageDto | null>(null);

export const updateLatestMessage = (message: MagicDoor.Api.ChatMessageDto) => {
  setLatestMessage(message);
};

export const useLatestMessage = () => latestMessage;
